<template>
  <section class="content">
    <div class="container-fluid">
      <div class="block-header">
        <h2>WhistleBlower</h2>
      </div>

      <div class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="card">
            <div class="header">
              <h2>List WhistleBlower</h2>
              <ul class="header-dropdown m-r--5 m-t--10">
                <router-link to="/main/whistleblower/tambah" class="btn btn-primary waves-effect" v-waves.button>
                  <i class="material-icons" style="color: #fff;">add_box</i>
                  <span>Tambah</span>
                </router-link>
              </ul>
            </div>

            <div class="body">
              <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                <!-- Search & Pagination Controls -->
                <div class="row">
                  <div class="col-sm-6">
                    <div class="dataTables_length">
                      <label>
                        Show
                        <select v-model="perPage" class="form-control input-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="dataTables_filter">
                      <label>
                        Search:
                        <input v-model="search" type="search" class="form-control input-sm" placeholder="">
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <table class="table table-bordered table-striped table-hover js-basic-example dataTable">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Nama Pelapor</th>
                      <th>Email</th>
                      <th>Pelaku</th>
                      <th>Jenis Pelangaran</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isLoading">
                      <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner"></i> Loading data...</td>
                    </tr>
                    <tr v-if="!isLoading && list.length === 0">
                      <td colspan="5" class="text-center">Data tidak ditemukan</td>
                    </tr>
                    <tr v-for="(item, index) in list" :key="item.id">
                      <td>{{ index + 1 + ((currentPage - 1) * perPage) }}</td>
                      <td>{{ item.namaPelapor || '-' }}</td>
                      <td>{{ item.email }}</td>
                      <td>
                        <ul v-if="item.pelakuList && item.pelakuList.length > 0">
                          <li v-for="pelaku in item.pelakuList" :key="pelaku.id">
                            {{ pelaku.namaPelaku }} - {{ pelaku.subjekPelakuPelanggaran }}
                          </li>
                        </ul>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <ul v-if="item.pelakuList && item.pelakuList.length > 0">
                          <li v-for="pelaku in item.pelakuList" :key="pelaku.id">
                            {{ pelaku.jenisPelanggaran }}
                          </li>
                        </ul>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <button @click="$router.push('/main/whistleblower/edit/' + item.id)"
                          class="btn bg-green waves-effect" style="padding: 4px 8px;">
                          <i class="material-icons">create</i>
                        </button>
                        <button @click="confirmDelete(item.id)" class="btn btn-danger waves-effect"
                          style="padding: 4px 8px;">
                          <i class="material-icons">delete</i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- Pagination -->
                <pagination :total-rows="result.totalElements" :per-page="result.size" v-model="currentPage">
                </pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import api from '@/helper/api'
import qs from 'qs'

export default {
  name: 'ListWhistleBlower',
  data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      isLoading: true
    }
  },
  methods: {
    getData() {
      const params = {
        search: this.search,
        page: this.currentPage - 1,
        size: this.perPage
      }

      this.isLoading = true
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')

      api.get('/getAllWhistleblower?' + qs.stringify(params))
        .then((res) => {
          this.result = res.data
          this.list = res.data.content
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    confirmDelete(id) {
      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, { text: 'Ok', closeModal: false }],
        dangerMode: true
      }).then(result => {
        if (result) this.delete(id)
      })
    },
    delete(id) {
      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
      api.delete('/whistleblower/' + id)
        .then((res) => {
          if (res.data.code === 200) {
            this.$toastr.s('Data berhasil dihapus.')
            this.getData()
          } else {
            this.$toastr.e('Gagal menghapus data.')
          }
          this.$swal.close()
        })
        .catch(() => {
          this.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.')
          this.$swal.close()
        })
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    currentPage() {
      this.getData()
    },
    perPage() {
      this.getData()
    },
    search() {
      this.getData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListWhistleBlower.vue